import { useEffect, useState } from 'react';

/**
 * Verdadeiro abaixo de 1024px.
 *
 * A primeira versão lia `matchMedia(...).matches` direto no corpo do
 * componente, sem assinar o evento: girar o aparelho ou redimensionar a janela
 * deixava o botão de menu com o comportamento da largura anterior — recolhia a
 * barra numa tela onde ela nem aparece.
 */
const QUERY = '(max-width: 63.99rem)';

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setNarrow(event.matches);
    mql.addEventListener('change', onChange);
    setNarrow(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return narrow;
}
